/* global G */
import sequenceModuleLogin from 'lib/sequence/module/login'
import redirectSequence from 'lib/sequence/module/adapter/router/redirect'
import routeComposition from 'trait/composition/route'
import showDialog from 'app/_shared/events/dialog'
import PlatformError from 'lib/util/error'

const descriptor = 'action::user::verify'

const middlewareOptions = {
  middleware: ({ error, invite, ...middleware }) => Object.values(middleware),
}

/**
 * User Verify Action
 *
 * Verifies the validity of the token (`key`) and logs the user in.
 *
 * Redirects to `verifyError` action if the token is invalid
 * Redirects to `guest/index` with a generic error message if
 * anything else goes wrong.
 *
 * @param {Gaia.AppModule.Spec} module - application module
 * @returns {function(): function(...[*]): Promise<*[]>}
 */

const verify = module => () => async (...args) => {
  const model = module[G.MODEL]
  const moduleState = module[G.STATE]

  const httpAdapter = model[G.ADAPTER][G.HTTP]
  const { version } = model[G.PROPS]
  const key = module[G.ADAPTER][G.SESSION][G.STATE][G.REF]

  const loginUrl = `/api/v${version}/public/tokenlogin/${key}`

  try {
    await httpAdapter.get({ url: loginUrl }, middlewareOptions)
  } catch (e) {
    console.error(e)
    // invalid or expired login link
    moduleState[G.ROUTE] = { [G.ACTION]: 'verifyError' }
    await redirectSequence(module)({})

    return args
  }

  try {
    // Omitting error middleware
    await httpAdapter.withContext(
      middlewareOptions,
      async () => await sequenceModuleLogin(module)(),
    )
  } catch (e) {
    console.error(e)
    moduleState[G.ROUTE] = routeComposition('guest', 'index')

    await redirectSequence(module)({})
    await showDialog(module, null, {})

    // Immediately interrupt the flow so that we do not end up rendering the "ok" screen
    throw new PlatformError(module, descriptor, { name: 'StateError', message: 'Login failed' })
  }

  return args
}

export default verify
